<script setup lang="ts">
const platform = useState('platform')

const { data: items } = await useApi(`/platform/${platform.value.slug}/locality`, {
  server: false,
  transform: (data) => data.localities.map(function (item) {
    return {
      value: item.name,
      coordinates: `${item.lat},${item.lng}`
    }
  }),
})

const selectedLocation = defineModel()
</script>

<template>
  <UInputMenu v-model="selectedLocation"
              :items="items || []"
              placeholder="Votre quartier"
              label-key="value"
              size="md"
              clear
              open-on-focus
  />
</template>